/*
 * Copyright (c) 2025, FusionAuth, All Rights Reserved
 */

interface ElPopover extends HTMLElement {
  anchor?: string;
  togglePopover: () => boolean;
  showPopover: () => void;
  hidePopover: () => void;
}

(async () => {
  const popoverConstructor = await customElements.whenDefined('el-popover');
  customElements.define('fa-tooltip', class extends (popoverConstructor as CustomElementConstructor) implements ElPopover {
    static observedAttributes = (popoverConstructor as any).observedAttributes;

    connectedCallback() {
      // @ts-ignore
      super.connectedCallback();
      [...document.querySelectorAll('[popovertarget]')]
          .filter(elem => elem.getAttribute('popovertarget') === this.id)
          .forEach(elem => {
            elem.addEventListener('mouseenter', () => {
              this.showPopover();
              // Wait for popover to be positioned by browser
              requestAnimationFrame(() => {
                this.positionArrow(elem);
              });
            });
            elem.addEventListener('mouseleave', () => this.hidePopover());
          });
    }

    positionArrow(target: Element) {
      const arrowTop = this.querySelector('.tooltip-arrow-top') as HTMLElement;
      const arrowBottom = this.querySelector('.tooltip-arrow-bottom') as HTMLElement;
      const arrowLeft = this.querySelector('.tooltip-arrow-left') as HTMLElement;
      const arrowRight = this.querySelector('.tooltip-arrow-right') as HTMLElement;
      
      if (!arrowTop || !arrowBottom || !arrowLeft || !arrowRight) return;

      const popoverRect = this.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();

      // Calculate which side the popover is on relative to the target
      const popoverCenterY = popoverRect.top + popoverRect.height / 2;
      const targetCenterY = targetRect.top + targetRect.height / 2;

      // Determine if popover is above or below target
      const isAbove = popoverCenterY < targetCenterY;

      // Hide all arrows first
      arrowTop.classList.add('hidden');
      arrowBottom.classList.add('hidden');
      arrowLeft.classList.add('hidden');
      arrowRight.classList.add('hidden');

      // Show the correct arrow
      if (isAbove) {
        // Popover is above target, show bottom arrow (points down)
        arrowBottom.classList.remove('hidden');
      } else {
        // Popover is below target, show top arrow (points up)
        arrowTop.classList.remove('hidden');
      }
    }
  });
})();
